module.exports = __webpack_public_path__ + "static/media/Essetional.7f12286e.svg";